import React from 'react';
import cn from 'classnames';
import { Badge, Icon } from '@economic/gaudi';
import { t } from '../../../shared/components/l10n/l10n';
import { AgreementLogo } from './AgreementLogo';

function Agreement({
    className,
    children,
    name,
    number,
    userId,
    isAdministrator,
    isDeveloper,
    enforce2Fa,
    logo,
    onClick,
    ...props
}: any) {
    const content = (
        <div className="flex flex-col mr-auto overflow-hidden">
            <span className="text-white truncate" title={name}>
                {name} {enforce2Fa ? <Icon name="secure-tick" /> : null}
            </span>
            <span className="text-grey-light text-xs">
                {number} {userId}
                {isAdministrator ? (
                    <Badge state="information" className="ml-2">
                        {t`AGREEMENT_SELECTOR_ADMINISTRATOR`}
                    </Badge>
                ) : null}
                {isDeveloper ? (
                    <Badge state="information" className="ml-2">
                        {t`AGREEMENT_SELECTOR_DEVELOPER`}
                    </Badge>
                ) : null}
            </span>
        </div>
    );

    if (typeof onClick === 'function') {
        return (
            <button
                {...props}
                onClick={onClick}
                className={cn('agreement_details__agreement cursor-pointer flex text-left w-full', className)}
                tabIndex={0}>
                <AgreementLogo agreementNumber={number} className="mr-3" />
                {content}
                {children}
            </button>
        );
    }

    return (
        <div
            {...props}
            className="agreement_details__agreement bg-purple-dark border-0 font-normal outline-none m-0 mr-auto overflow-hidden text-left whitespace-no-wrap w-full pl-4 pr-10">
            {content}
        </div>
    );
}

export default Agreement;
